import _ from 'underscore';
import axiosInstance from '../config/axiosInstance';
import errorHandler from '../utils/errorHandler';

export const login = async (info) => {
  try {
    const { data } = await axiosInstance(false).post('/user/login', info);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const requestPassword = async (info) => {
  try {
    const { data } = await axiosInstance(false).post('/user/request-password', info);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const resetPassword = async (info) => {
  try {
    const { data } = await axiosInstance(false).post('/user/reset-password', info);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const getUsersPaginated = async ({ filters, continuationToken, order, rowsPerPage }) => {
  try {
    const headers = { 'x-page-size': rowsPerPage, 'x-is-paginated': true };

    if (filters && !_.isEmpty(filters)) {
      headers['x-filters'] = JSON.stringify(filters);
    }

    if (continuationToken) {
      headers['x-continuation-token'] = continuationToken;
    }

    if (order && order.by) {
      headers['x-order'] = `${order.by} ${order.type}`;
    }

    const { data } = await axiosInstance().get('/user', { headers });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const getAllUsers = async ({ filters, order }) => {
  try {
    const headers = { 'x-is-paginated': false };

    if (filters && !_.isEmpty(filters)) {
      headers['x-filters'] = JSON.stringify(filters);
    }

    if (order && order.by) {
      headers['x-order'] = `${order.by} ${order.type}`;
    }

    const { data } = await axiosInstance().get('/user', { headers });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const getUsersById = async (id) => {
  try {
    const { data } = await axiosInstance().get(`/user/${id}`);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const createUsers = async (values) => {
  try {
    const { data } = await axiosInstance().post(`/user`, values, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const updateUsers = async (values, id) => {
  try {
    const { data } = await axiosInstance().put(`/user/${id}`, values, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const deleteUsers = async (id) => {
  try {
    const { data } = await axiosInstance().delete(`/user/${id}`);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};
